import { combineReducers } from "redux";

import { userAuth } from "./UserAuthReducer";
import { item } from "./ItemDimensionAnalysisReducer";
import { loader } from './loader.reducer';

const rootReducer = combineReducers({
    userAuth,
    item,
    loader
});

export default rootReducer;
